import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

export type CrmStatsMode = "funnels" | "groups";

export interface FetchCrmLeadStatsParams {
  workspaceId: string;
  mode: CrmStatsMode;
  funnelId: string | null;
  isIntegrationFunnel: boolean;
  includeLegacyNullFunnel: boolean;
  groupId: string | null;
}

export interface CrmLeadStatsResult {
  totalCount: number;
  newLast7d: number;
  withAppointment: number;
  stageCount: number;
  avgPerStage: number;
}

/** Chave para invalidar cache ao mudar funil/grupo ou flags. */
export function buildCrmStatsContextKey(p: FetchCrmLeadStatsParams): string {
  return `${p.mode}:${p.funnelId ?? "none"}:${p.groupId ?? "none"}:${p.isIntegrationFunnel ? "1" : "0"}:${p.includeLegacyNullFunnel ? "1" : "0"}`;
}

export async function fetchCrmLeadStats(
  supabase: SupabaseClient<Database>,
  params: FetchCrmLeadStatsParams,
): Promise<CrmLeadStatsResult> {
  const { data, error } = await supabase.rpc("get_crm_lead_stats", {
    p_workspace_id: params.workspaceId,
    p_mode: params.mode,
    p_funnel_id: params.mode === "funnels" ? params.funnelId : null,
    p_is_integration_funnel: params.mode === "funnels" ? params.isIntegrationFunnel : false,
    p_include_legacy_null_funnel: params.mode === "funnels" ? params.includeLegacyNullFunnel : false,
    p_group_id: params.mode === "groups" ? params.groupId : null,
  });

  if (error) throw error;

  const row = Array.isArray(data) ? data[0] : null;
  if (!row) {
    return {
      totalCount: 0,
      newLast7d: 0,
      withAppointment: 0,
      stageCount: 0,
      avgPerStage: 0,
    };
  }

  return {
    totalCount: Number(row.total_count ?? 0),
    newLast7d: Number(row.new_last_7d ?? 0),
    withAppointment: Number(row.with_appointment ?? 0),
    stageCount: Number(row.stage_count ?? 0),
    avgPerStage: Number(row.avg_per_stage ?? 0),
  };
}
